import '../css/creator_showcase.scss';


loadjs.ready(['jquery', 'core'], function() {
    var $mainCover = $('#main-cover');
    var player;
    var ready = false;
    var done = false;

    if (videoId) {
        var $button = $('#play-button');
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        window.onYouTubeIframeAPIReady = function() {
            player = new YT.Player('player', {
                height: $mainCover.height(),
                width: $mainCover.width(),
                videoId: videoId,
                playerVars: {
                    'playsinline': 1
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
        }
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // 4. The API will call this function when the video player is ready.
        function onPlayerReady(event) {
            ready = true;
        }

        // 5. The API calls this function when the player's state changes.
        //    The function indicates that when playing a video (state=1),
        //    the player should play for six seconds and then stop.
        function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.PLAYING && !done) {
                done = true;
            }
        }
        function stopVideo() {
            player.stopVideo();
        }


        var ts;
        $button.on('click', function () {
            $mainCover.find('.image').hide();
            $mainCover.find('.cover-heading').hide();
            $mainCover.find('.cover-video').removeClass('is-hidden');

            gtag('event', 'video_play', {
                'event_label': brand.name,
                'event_category': 'creators-voice',
            });

            if (ts) {
                clearInterval(ts);
            }
            ts = setInterval(function () {
                if (ready) {
                    player.playVideo();
                    clearInterval(ts);
                }
            }, 500);
            return false;
        });
    }

})
